import { render, staticRenderFns } from "./KaihatsuTypeDiscriptionModal.vue?vue&type=template&id=6ccf8c94&scoped=true&"
import script from "./KaihatsuTypeDiscriptionModal.vue?vue&type=script&lang=js&"
export * from "./KaihatsuTypeDiscriptionModal.vue?vue&type=script&lang=js&"
import style0 from "./KaihatsuTypeDiscriptionModal.vue?vue&type=style&index=0&id=6ccf8c94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf8c94",
  null
  
)

export default component.exports